import { gql } from '@apollo/client';
export const getPlanFromType = gql `
  query getPlanFromType($planType: PlanTypeEnumEnum!, $marketCode: String!) {
    plans(where: { type: { _eq: $planType }, market_code: { _eq: $marketCode } }) {
      id
    }
  }
`;
